exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1pdINh6c4O0RBawz8YAln5{width:100%}html[dir] ._1pdINh6c4O0RBawz8YAln5 .ocG6IWfJpV-L4TtLekVoS{margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"container": "_1pdINh6c4O0RBawz8YAln5",
	"storageAccount": "ocG6IWfJpV-L4TtLekVoS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{"plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./obj/options/config/mail/owa-storage-accounts-option/lib/components/StorageAccountsListView.scss
// module id = 4999
// module chunks = 2